/**
 * Environment Configuration
 * Centralized configuration for all environment variables and paths
 */

const trimTrailingSlashes = (url) =>
  typeof url === 'string' ? url.replace(/\/+$/, '') : '';

// Node API root (no trailing slash) — served app + install redirects
export const NODE_API_URL =
  trimTrailingSlashes(process.env.REACT_APP_API_URL) ||
  'https://api.liftfund.app';
export const NODE_API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH || '/api';
// React App Configuration
export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN || 'http://localhost:3000';
export const REACT_APP_BASE_PATH = process.env.REACT_APP_BASE_PATH || '';

// Shopify Configuration
export const SHOPIFY_API_KEY = process.env.REACT_APP_SHOPIFY_API_KEY || '2bbd326082534dfba02bd66da8f8f589';

// Environment Detection
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

// Full API URL
export const API_BASE_URL = `${NODE_API_URL}${NODE_API_BASE_PATH}`;

/** Root URL with ?shop / ?shop&host (embedded) for install / OAuth style redirects */
export const buildNodeApiEntryUrl = (shop, host = null) => {
  if (!shop) return `${NODE_API_URL}/`;
  return host
    ? `${NODE_API_URL}/?shop=${shop}&host=${host}`
    : `${NODE_API_URL}/?shop=${shop}`;
};

// Full React App URL
export const APP_BASE_URL = `${REACT_APP_DOMAIN}${REACT_APP_BASE_PATH}`;

// Export all config
const config = {
  // Node API
  nodeApi: {
    url: NODE_API_URL,
    basePath: NODE_API_BASE_PATH,
    fullUrl: API_BASE_URL,
  },
  // React App
  reactApp: {
    domain: REACT_APP_DOMAIN,
    basePath: REACT_APP_BASE_PATH,
    fullUrl: APP_BASE_URL,
  },
  // Shopify
  shopify: {
    apiKey: SHOPIFY_API_KEY,
  },
  // Environment
  env: {
    isProduction: IS_PRODUCTION,
    isDevelopment: IS_DEVELOPMENT,
    nodeEnv: process.env.NODE_ENV,
  },
};

export default config;

